<mat-tab-group class="mat-tab-group-principal" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="{{ 'calibrateEquipmentEdit.calibrationData.title' | translate }}">

    <form>

      <mat-card class="card">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'calibrateEquipmentEdit.calibrationData.title' | translate }}
          </mat-toolbar>

          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

            <div fxFlex="33" fxFlex.lt-md="100%">
              <div fxLayout="column" class="flexwrap">

                @if (calibration.id == null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentList.filter.client.label' | translate }}</mat-label>
                      <mat-select #clientSelect name="idClientSelected" [(ngModel)]="idClientSelected">
                        @if (clientSelect.focused) {
                          <mat-select-filter [displayMember]="'name'" [array]="clients"
                            (filteredReturn)="clientsFiltered =$event" [noResultsMessage]="'common.noResults' | translate"
                          [placeholder]="'common.selectFilterPlaceholder' | translate"></mat-select-filter>
                        }
                        <mat-option value="-1"> -- {{ 'calibrationResponsibleType.internal' | translate | uppercase }} --
                        </mat-option>
                        @for (client of clientsFiltered; track client) {
                          <mat-option [value]="client.id">
                            {{client.name}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }

                @if (calibration.id == null && idClientSelected != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.equipment.label' | translate }}</mat-label>
                      <input matInput [ngModel]="equipment.name" #trigger="matAutocompleteTrigger"
                        [matAutocomplete]="auto" (keyup)="lookupEquipment($event)" [ngModelOptions]="{standalone: true}">
                      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
                        (optionSelected)="onSensorChange($event, trigger)">
                        @for (item of equipmentAutoComplete; track item; let index = $index) {
                          <mat-option [value]="item">
                            {{ item.name}} ({{item.serialNum}})
                          </mat-option>
                        }
                      </mat-autocomplete>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.patterns.dialog.equipment.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (calibration.id == null && idClientSelected != null) {
                  <div fxFlex>
                    <a class="under-card-link" style="cursor: pointer;margin: inherit;" (click)="createEquipment()">
                      {{ 'calibrateEquipmentEdit.general.equipment.notExists' | translate }}
                    </a>
                  </div>
                }

                @if (calibration.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.name.label' | translate }}</mat-label>
                      <input matInput
                        name="name" [(ngModel)]="equipment.name" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.name.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (equipment.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.equipment.label' | translate }}</mat-label>
                      <input matInput
                        name="equipment" [(ngModel)]="equipment.equipment" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.equipment.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (equipment.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.maker.label' | translate }}</mat-label>
                      <input matInput
                        name="maker" [(ngModel)]="equipment.maker" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.maker.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (equipment.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.model.label' | translate }}</mat-label>
                      <input matInput
                        name="model" [(ngModel)]="equipment.model" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.model.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (equipment.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.serialNum.label' | translate }}</mat-label>
                      <input matInput
                        name="serialNum" [(ngModel)]="equipment.serialNum" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.serialNum.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

              </div>
            </div>

            <div fxFlex="33" fxFlex.lt-md="100%">

              <div fxLayout="column" class="flexwrap">

                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.certificateNum.label' | translate }}</mat-label>
                    <input matInput
                      name="certificateNum" [(ngModel)]="calibration.certificateNum" [disabled]="isEditable()">
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.certificateNum.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex>
                  <mat-form-field style="width: 95%;">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.calibrateDate.label' | translate }}</mat-label>
                    <input matInput [matDatepicker]="calibrateDate" name="calibrationDate"
                      [ngModel]="calibration.calibrationDate" (blur)="saveDate('calibrationDate', $event)"
                      (dateChange)="saveDate('calibrationDate', $event)" [disabled]="isEditable()"
                      [max]="maxDateCalibration">
                    <mat-datepicker-toggle matSuffix [for]="calibrateDate"></mat-datepicker-toggle>
                    <mat-datepicker #calibrateDate >
                    </mat-datepicker>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.calibrateDate.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex>
                  <mat-form-field style="width: 95%;">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.expirationDate.label' | translate }}</mat-label>
                    <input matInput [matDatepicker]="expirationDate" name="expirationDate"
                      [ngModel]="calibration.expirationDate" (blur)="saveDate('expirationDate', $event)"
                      (dateChange)="saveDate('expirationDate', $event)" [disabled]="isEditable()">
                    <mat-datepicker-toggle matSuffix [for]="expirationDate"></mat-datepicker-toggle>
                    <mat-datepicker #expirationDate >
                    </mat-datepicker>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.expirationDate.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                @if (calibration.id != null) {
                  <div fxFlex>
                    <mat-checkbox name="showExpirationDate" [(ngModel)]="calibration.showExpirationDate">
                      {{'calibrateEquipmentEdit.general.showExpirationDate.label' | translate }}
                    </mat-checkbox>
                  </div>
                }

                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.projectNumber.label' | translate }}</mat-label>
                    <input matInput
                      name="projectNo" [(ngModel)]="calibration.projectNo" [disabled]="isEditable()">
                  </mat-form-field>
                </div>

                @if (calibration.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.status.label' | translate }}</mat-label>
                      <mat-select name="idStatus" [(ngModel)]="calibration.idStatus" disabled>
                        @for (item of statuses; track item) {
                          <mat-option [value]="item.id">
                            {{ 'calibrationStatus.' + item.translation | translate }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }

                @if (calibration.currentVersion != 0 && calibration.currentVersion != null) {
                  <div fxFlex>
                    <div fxLayout="row">
                      <div fxFlex="50">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'calibrateEquipmentEdit.general.currentVersion.label' | translate }}</mat-label>
                          <input matInput
                            name="currentVersion" [ngModel]="calibration.currentVersion" disabled>
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'calibrateEquipmentEdit.general.signedVersion.label' | translate }}</mat-label>
                          <input matInput
                            name="signedVersion" [ngModel]="calibration.signedVersion" disabled>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }

              </div>

            </div>

            @if (equipment.id != null) {
              <div fxFlex="33" fxFlex.lt-md="100%">
                <div fxLayout="column" class="flexwrap">
                  <div fxFlex>
                    <mat-form-field style="width: 95%;">
                      <mat-label>{{ 'calibrateEquipmentEdit.client.name.label' | translate }}</mat-label>
                      <input matInput name="clientName" [value]="clientName" disabled>
                    </mat-form-field>
                  </div>
                  <div fxFlex>
                    <mat-label>{{ 'calibrateEquipmentEdit.client.address.label' | translate }}</mat-label>
                    <textarea matInput
                    [value]="clientAddress" name="clientAddress" style="resize: none;" disabled> </textarea>
                  </div>
                </div>
              </div>
            }

          </div>

        </mat-card-content>
      </mat-card>

      @if (calibration.id != null) {
        <mat-card class="card">
          <mat-card-content>
            <mat-toolbar color="secondary">
              {{ 'calibrateEquipmentEdit.environmentalConditions.title' | translate }}
            </mat-toolbar>
            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.place.label' | translate }}</mat-label>
                  <mat-select required name="idPlace" [(ngModel)]="calibration.idPlace" [disabled]="isEditable()">
                    @for (item of places; track item) {
                      <mat-option [value]="item.id">
                        {{ 'calibrationPlace.' + item.translation | translate }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.calibrationData.place.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.temperature.label' | translate }}</mat-label>
                  <input matInput
                    name="temperature" [(ngModel)]="calibration.temperature" [disabled]="isEditable()">
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.environmentalConditions.temperature.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.humidity.label' | translate }}</mat-label>
                  <input matInput
                    name="humidity" [(ngModel)]="calibration.humidity" [disabled]="isEditable()">
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.environmentalConditions.humidity.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.pressure.label' | translate }}</mat-label>
                  <input matInput
                    name="pressure" [(ngModel)]="calibration.pressure" [disabled]="isEditable()">
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.environmentalConditions.pressure.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="30" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{'calibrateEquipmentEdit.calibrationData.variables.label' | translate }}</mat-label>
                  <mat-select multiple [(ngModel)]="variablesSelected" name="idsVariable" [disabled]="isEditable()">
                    @for (item of variables; track item) {
                      <mat-option checkboxPosition="before" [value]="item"
                        (onSelectionChange)="onChangeVariableCheck($event)">
                        {{ 'variable.' + item.translation | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-md="100%" style="align-content: center; padding: 10px;">
                <mat-checkbox name="multichannel" [(ngModel)]="calibration.multichannel" [disabled]="isEditable()">
                  {{'calibrateEquipmentEdit.general.multichannel.label' | translate }}
                </mat-checkbox>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }

      @if (calibration.id != null) {
        <mat-card class="card">
          <mat-card-content>
            <mat-tab-group style="width: 100%;" (selectedTabChange)="onVariableTabChange($event)">
              @for (variable of calibration.variables; track variable; let indexVariable = $index) {
                <mat-tab style="min-height: 50vh;"
                  label="{{'variable.' + variable.variableTranslation | translate }}">
                  <mat-card class="card">
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.general.title' | translate : {variable: ('variable.' +
                        variable.variableTranslation | translate) } }}
                      </mat-toolbar>
                      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                        <div fxFlex="33" fxFlex.lt-md="100%">
                          <mat-form-field class="campoFormulario">
                            <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.unit.label' | translate }}</mat-label>
                            <mat-select name="unit{{variable.idVariable}}" [(ngModel)]="variable.idUnit" required
                              (selectionChange)="onUnitChange(indexVariable, $event)" [disabled]="isEditable()">
                              @for (item of variableUnits; track item) {
                                <mat-option [value]="item.id">
                                  {{item.unit}}
                                </mat-option>
                              }
                            </mat-select>
                            <mat-error>
                              {{ 'calibrateEquipmentEdit.calibrationData.unit.error' | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div fxFlex="33" fxFlex.lt-md="100%">
                          <mat-form-field class="campoFormulario">
                            <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.procedure.label' | translate }}
                            </mat-label>
                            <mat-select required name="idProcedure{{variable.idVariable}}"
                              [(ngModel)]="variable.idProcedure" [disabled]="isEditable()">
                              @for (item of procedures; track item) {
                                <mat-option [value]="item.id">
                                  {{ item.name }} ({{ item.description }})
                                </mat-option>
                              }
                            </mat-select>
                            <mat-error>
                              {{ 'calibrateEquipmentEdit.calibrationData.procedure.error' | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      @if (showExtraField(variable)) {
                        <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                          <div fxFlex="33" fxFlex.lt-md="100%">
                            <mat-form-field class="campoFormulario">
                              <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.idUnitInput.label' | translate }}
                              </mat-label>
                              <mat-select name="idUnitInput{{variable.idVariable}}" [(ngModel)]="variable.idUnitInput"
                                required [disabled]="isEditable()">
                                @for (item of variableUnits; track item) {
                                  <mat-option [value]="item.id">
                                    {{item.unit}}
                                  </mat-option>
                                }
                              </mat-select>
                              <mat-error>
                                {{ 'calibrateEquipmentEdit.calibrationData.idUnitInput.error' | translate }}
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div fxFlex="17" fxFlex.lt-md="100%">
                            <mat-form-field class="campoFormulario">
                              <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.' + getExtraFieldName(variable) + '.label' | translate }}</mat-label>
                              <input matInput name="extraField{{variable.idVariable}}" [(ngModel)]="variable.extraField"
                                [disabled]="isEditable()">
                              <mat-error>
                                {{ 'calibrateEquipmentEdit.calibrationData.' + getExtraFieldName(variable) + '.error' |
                                translate }}
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div fxFlex="16" fxFlex.lt-md="100%">
                            <mat-form-field class="campoFormulario">
                              <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.idUnitExtra.label' | translate }}
                              </mat-label>
                              <mat-select name="idUnitExtra{{variable.idVariable}}" [(ngModel)]="variable.idUnitExtra"
                                required [disabled]="isEditable()">
                                @for (item of variableUnitsExtra; track item) {
                                  <mat-option [value]="item.id">
                                    {{item.unit}}
                                  </mat-option>
                                }
                              </mat-select>
                              <mat-error>
                                {{ 'calibrateEquipmentEdit.calibrationData.idUnitExtra.error' | translate }}
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      }
                    </mat-card-content>
                  </mat-card>
                  @if (calibration.multichannel) {
                    <mat-card class="card">
                      <mat-card-content>
                        <mat-toolbar color="secondary">
                          {{ 'calibrateEquipmentEdit.multichannel.general.title' | translate }}
                        </mat-toolbar>
                        <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                          <div fxFlex="100" fxFlex.lt-md="100%">
                            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                              @if (calibration.multichannel) {
                                <div fxFlex="33" fxFlex.lt-md="100%">
                                  <mat-form-field class="campoFormulario">
                                    <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.channelNumber.label' | translate }}</mat-label>
                                    <input matInput type="number"
                                      name="channelNumber" [ngModel]="calibration.channelNumber" [disabled]="true"
                                      (ngModelChange)="onCountMultichannel(indexVariable, $event)">
                                    <mat-error>
                                      {{ 'calibrateEquipmentEdit.environmentalConditions.channelNumber.error' | translate }}
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                              }
                              <!--<div fxFlex="10" fxFlex.lt-md="100%" *ngIf="variable?.valuesMultichannel?.length > 0">
                              <button mat-icon-button (click)="openDialogMultichannel(indexVariable)" *ngIf="!isEditable()">
                                <mat-icon>mode_edit</mat-icon>
                              </button>
                            </div>-->
                          </div>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (showAmbientConditions(indexVariable)) {
                  <mat-card class="card">
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.ambientConditions.title' | translate }}
                      </mat-toolbar>
                      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                        <div fxFlex="20" fxFlex.lt-md="100%">
                          <mat-form-field class="campoFormulario">
                            <mat-label>{{ 'calibrateEquipmentEdit.ambientConditions.pressureUsed.label' | translate }}</mat-label>
                            <input matInput
                              name="pressureUsed" [(ngModel)]="variable.ambientConditions.pressureUsed"
                              [disabled]="isEditable()">
                            <mat-error>
                              {{ 'calibrateEquipmentEdit.ambientConditions.pressureUsed.error' | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div fxFlex="20" fxFlex.lt-md="100%">
                          <mat-form-field class="campoFormulario">
                            <mat-label>{{ 'calibrateEquipmentEdit.ambientConditions.temperature.label' | translate }}</mat-label>
                            <input matInput
                              name="particleTemperature" [(ngModel)]="variable.ambientConditions.temperature"
                              [disabled]="isEditable()">
                            <mat-error>
                              {{ 'calibrateEquipmentEdit.ambientConditions.temperature.error' | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div fxFlex="20" fxFlex.lt-md="100%">
                          <mat-form-field class="campoFormulario">
                            <mat-label>{{ 'calibrateEquipmentEdit.ambientConditions.oilUsed.label' | translate }}</mat-label>
                            <input matInput
                              name="oilUsed" [(ngModel)]="variable.ambientConditions.oilUsed" [disabled]="isEditable()">
                            <mat-error>
                              {{ 'calibrateEquipmentEdit.ambientConditions.oilUsed.error' | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (!showAmbientConditions(indexVariable) || (!showParticleCount(indexVariable) && !calibration.multichannel)) {
                  <mat-card class="card">
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.calibrationData.title' | translate }}
                        @if (!isEditable()) {
                          <button mat-icon-button color="accent" (click)="newConfigRow(indexVariable)">
                            <mat-icon>add</mat-icon>
                          </button>
                        }
                      </mat-toolbar>
                      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                        <table #configTable mat-table matSort [dataSource]="variable.config" style="width: 100%;">
                          <!-- range Column -->
                          <ng-container matColumnDef="range">
                            <th mat-header-cell *matHeaderCellDef>
                            {{ 'calibrateEquipmentEdit.config.cols.range' | translate }} </th>
                            <td mat-cell *matCellDef="let item">
                              <div style="white-space: pre-line;">
                                @if (item.rangeInit != null && item.rangeEnd != null) {
                                  <span>
                                    {{ item.rangeInit }} - {{ item.rangeEnd }} {{variable.unitName}}
                                  </span>
                                }
                                @if (item.rangeInit != null && item.rangeEnd == null) {
                                  <span>
                                    {{ item.rangeInit }} {{variable.unitName}}
                                  </span>
                                }
                              </div>
                            </td>
                          </ng-container>
                          <!-- resolution Column -->
                          <ng-container matColumnDef="resolution">
                            <th mat-header-cell *matHeaderCellDef>
                            {{ 'calibrateEquipmentEdit.config.cols.resolution' | translate }} </th>
                            <td mat-cell *matCellDef="let item">
                              <div style="white-space: pre-line;"> {{ item.resolution }} </div>
                            </td>
                          </ng-container>
                          <!-- tolerance Column -->
                          <ng-container matColumnDef="tolerance">
                            <th mat-header-cell *matHeaderCellDef>
                            {{ 'calibrateEquipmentEdit.config.cols.tolerance' | translate }} </th>
                            <td mat-cell *matCellDef="let item">
                              <div style="white-space: pre-line;"> {{ item.tolerance }} </div>
                            </td>
                          </ng-container>
                          <!-- uncertaintyResolution Column -->
                          <ng-container matColumnDef="uncertaintyResolution">
                            <th mat-header-cell *matHeaderCellDef>
                            {{ 'calibrateEquipmentEdit.config.cols.uncertaintyResolution' | translate }} </th>
                            <td mat-cell *matCellDef="let item">
                              <div style="white-space: pre-line;"> {{ item.uncertaintyResolution }} </div>
                            </td>
                          </ng-container>
                          <!-- Values Column -->
                          <ng-container matColumnDef="values">
                            <th mat-header-cell *matHeaderCellDef>
                            {{ 'calibrateEquipmentEdit.asLeft.cols.value.label' | translate }} </th>
                            <td mat-cell *matCellDef="let element"> {{ joinListValuesConfig(element) }} </td>
                          </ng-container>
                          <!-- Button edit Column -->
                          <ng-container matColumnDef="edit">
                            <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                            <td mat-cell *matCellDef="let element; let i = index">
                              @if (!isEditable()) {
                                <button mat-icon-button (click)="editConfigRow(indexVariable, i)">
                                  <mat-icon>mode_edit</mat-icon>
                                </button>
                              }
                            </td>
                          </ng-container>
                          <!-- Button delete Column -->
                          <ng-container matColumnDef="delete">
                            <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                            <td mat-cell *matCellDef="let element; let i = index">
                              @if (!isEditable()) {
                                <button mat-icon-button (click)="deleteConfigRow(indexVariable, i)">
                                  <mat-icon>delete</mat-icon>
                                </button>
                              }
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="configCols"></tr>
                          <tr mat-row *matRowDef="let row; columns: configCols;"></tr>
                        </table>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (!showAmbientConditions(indexVariable) || (!showParticleCount(indexVariable) && !calibration.multichannel)) {
                  <mat-card class="card">
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.pattern.title' | translate }}
                        @if (!isEditable()) {
                          <button mat-icon-button color="accent" (click)="newPatternRow(indexVariable)">
                            <mat-icon>add</mat-icon>
                          </button>
                        }
                      </mat-toolbar>
                      <div fxLayout="column" class="flexwrap">
                        <div fxFlex>
                          <table #patternsTable mat-table matSort [dataSource]="variable.patterns" style="width: 100%;">
                            <!-- name Column -->
                            <ng-container matColumnDef="name">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.pattern.cols.name' | translate }} </th>
                              <td mat-cell *matCellDef="let item">
                                <div style="white-space: pre-line;"> {{ item.name }} </div>
                              </td>
                            </ng-container>
                            <!-- equipment Column -->
                            <ng-container matColumnDef="equipment">
                              <th mat-header-cell *matHeaderCellDef>
                                {{ 'calibrateEquipmentEdit.pattern.cols.equipment' | translate }}
                              </th>
                              <td mat-cell *matCellDef="let item">
                                <div style="white-space: pre-line;"> {{ item.equipment?.equipment }} </div>
                              </td>
                            </ng-container>
                            <!-- maker Column -->
                            <ng-container matColumnDef="maker">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{ 'calibrateEquipmentEdit.pattern.cols.maker' | translate }}
                              </th>
                              <td mat-cell *matCellDef="let item"> {{item.equipment?.maker}} </td>
                            </ng-container>
                            <!-- model Column -->
                            <ng-container matColumnDef="model">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                              {{ 'calibrateEquipmentEdit.pattern.cols.model' | translate }} </th>
                              <td mat-cell *matCellDef="let item"> {{item.equipment?.model}} </td>
                            </ng-container>
                            <!-- serialNum Column -->
                            <ng-container matColumnDef="serialNum">
                              <th mat-header-cell *matHeaderCellDef>
                                {{ 'calibrateEquipmentEdit.pattern.cols.serialNum' | translate }}
                              </th>
                              <td mat-cell *matCellDef="let item">{{ item.equipment?.serialNum }} </td>
                            </ng-container>
                            <!-- uncertainty Column -->
                            <ng-container matColumnDef="uncertainty">
                              <th mat-header-cell *matHeaderCellDef>
                                {{ 'calibrateEquipmentEdit.pattern.cols.uncertainty' | translate }}
                              </th>
                              <td mat-cell *matCellDef="let item">{{ getWorstUncertainty(item) }} </td>
                            </ng-container>
                            <!-- Button edit Column -->
                            <ng-container matColumnDef="edit">
                              <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                              <td mat-cell *matCellDef="let element; let i = index">
                                @if (!isEditable()) {
                                  <button mat-icon-button (click)="editPatternRow(indexVariable, i)">
                                    <mat-icon>mode_edit</mat-icon>
                                  </button>
                                }
                              </td>
                            </ng-container>
                            <!-- Button delete Column -->
                            <ng-container matColumnDef="delete">
                              <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                              <td mat-cell *matCellDef="let element; let i = index">
                                @if (!isEditable()) {
                                  <button mat-icon-button (click)="deletePatternRow(indexVariable, i)">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                }
                              </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="patternsCols"></tr>
                            <tr mat-row *matRowDef="let row; columns: patternsCols;"></tr>
                          </table>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (!showAmbientConditions(indexVariable) && !calibration.multichannel) {
                  <mat-card class="card">
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.asFound.title' | translate }}
                        @if (!isEditable()) {
                          <button mat-icon-button color="accent" (click)="newAsFoundRow(indexVariable)">
                            <mat-icon>add</mat-icon>
                          </button>
                        }
                      </mat-toolbar>
                      <div fxLayout="column" class="flexwrap">
                        <div fxFlex>
                          <table #asFoundTable mat-table [dataSource]="variable.asFound" style="width: 100%;">
                            <!-- Number Column -->
                            <ng-container matColumnDef="number">
                              <th mat-header-cell *matHeaderCellDef> </th>
                              <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }} </td>
                            </ng-container>
                            <!-- Point Column -->
                            <ng-container matColumnDef="point">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asFound.cols.point.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element"> {{ element.point }} </td>
                            </ng-container>
                            <!-- Pattern Column -->
                            <ng-container matColumnDef="pattern">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asFound.cols.pattern.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element"> {{ element.pattern }} </td>
                            </ng-container>
                            <!-- Equipment Column -->
                            <ng-container matColumnDef="equipment">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asFound.cols.equipment.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                {{ element.equipment | number:'1.' + getDecimalsResolution(indexVariable, element.point) +
                                '-' + getDecimalsResolution(indexVariable, element.point) }}
                              </td>
                            </ng-container>
                            <!-- Correction Column -->
                            <ng-container matColumnDef="correction">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asFound.cols.correction.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element"> {{ element.correction }} </td>
                            </ng-container>
                            <!-- Button edit Column -->
                            <ng-container matColumnDef="edit">
                              <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                              <td mat-cell *matCellDef="let element; let i = index">
                                @if (!isEditable()) {
                                  <button mat-icon-button (click)="editAsFoundRow(indexVariable, i)">
                                    <mat-icon>mode_edit</mat-icon>
                                  </button>
                                }
                              </td>
                            </ng-container>
                            <!-- Button delete Column -->
                            <ng-container matColumnDef="delete">
                              <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                              <td mat-cell *matCellDef="let element; let i = index">
                                @if (!isEditable()) {
                                  <button mat-icon-button (click)="deleteAsFoundRow(indexVariable, i)">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                }
                              </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="asFoundCols"></tr>
                            <tr mat-row *matRowDef="let row; columns: asFoundCols;"></tr>
                          </table>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (!showAmbientConditions(indexVariable) && !calibration.multichannel) {
                  <mat-card class="card">
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.asLeft.title' | translate }}
                      </mat-toolbar>
                      <div fxLayout="column" class="flexwrap">
                        <div fxFlex>
                          <table #asLeftTable mat-table [dataSource]="getAsLeftList(indexVariable)" style="width: 100%;">
                            <!-- Number Column -->
                            <ng-container matColumnDef="number">
                              <th mat-header-cell *matHeaderCellDef> </th>
                              <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }} </td>
                            </ng-container>
                            <!-- Point Column -->
                            <ng-container matColumnDef="point">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asLeft.cols.point.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element"> {{ element.point }} </td>
                            </ng-container>
                            <!-- Pattern Column -->
                            <ng-container matColumnDef="pattern">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asLeft.cols.pattern.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element"> {{ element.pattern }} </td>
                            </ng-container>
                            <!-- Values Column -->
                            <ng-container matColumnDef="value">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asLeft.cols.value.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element"> {{ joinListValues(indexVariable, element) }} </td>
                            </ng-container>
                            <!-- Average Column -->
                            <ng-container matColumnDef="average">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asLeft.cols.average.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.average">
                                  {{ element.average | number:'1.' + (getDecimalsResolution(indexVariable, element.point) +
                                  1) + '-' + (getDecimalsResolution(indexVariable, element.point) + 1) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- Correction Column -->
                            <ng-container matColumnDef="correction">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asLeft.cols.correction.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.correction">
                                  {{ element.correction | number:'1.' + getDecimalsPattern(element.pattern) + '-' +
                                  getDecimalsPattern(element.pattern) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- U Column -->
                            <ng-container matColumnDef="U">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.U">
                                  {{ element.U | number:'1.' + getDecimalsUncertainty(indexVariable, element.point) + '-' +
                                  getDecimalsUncertainty(indexVariable, element.point) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- cPlusU Column -->
                            <ng-container matColumnDef="cPlusU">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.asLeft.cols.cPlusU.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [class]="styleCPlusU(indexVariable, element.point, element.cPlusU)"
                                  [matTooltip]="element.cPlusU">
                                  {{ element.cPlusU | number:'1.' + getDecimalsUncertainty(indexVariable, element.point) +
                                  '-' + getDecimalsUncertainty(indexVariable, element.point) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- Button see Column -->
                            <ng-container matColumnDef="edit">
                              <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                              <td mat-cell *matCellDef="let element; let i = index">
                                @if (!isEditable()) {
                                  <button mat-icon-button
                                    (click)="editAsLeftRow(indexVariable, element.indexConfig, i)">
                                    <mat-icon>mode_edit</mat-icon>
                                  </button>
                                }
                              </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="asLeftCols"></tr>
                            <tr mat-row *matRowDef="let row; columns: asLeftCols;"></tr>
                          </table>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (!showAmbientConditions(indexVariable)&& !calibration.multichannel) {
                  <mat-card class="card">
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.uncertainties.title' | translate }}
                      </mat-toolbar>
                      <div fxLayout="column" class="flexwrap">
                        <div fxFlex>
                          <table #uncertaintiesTable mat-table [dataSource]="getAsLeftList(indexVariable)"
                            style="width: 100%;">
                            <!-- Number Column -->
                            <ng-container matColumnDef="number">
                              <th mat-header-cell *matHeaderCellDef> </th>
                              <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }} </td>
                            </ng-container>
                            <!-- Point Column -->
                            <ng-container matColumnDef="point">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.average.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element; let i = index">
                                <span [matTooltip]="element.average">
                                  {{ element.average | number:'1.' + getDecimalsResolution(indexVariable, element.point) +
                                  '-' + getDecimalsResolution(indexVariable, element.point) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- uRep Column -->
                            <ng-container matColumnDef="uRep">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.uRep.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.uRep">
                                  {{ element.uRep | number:'1.' + getDecimalsUncertainty(indexVariable, element.point) + '-'
                                  + getDecimalsUncertainty(indexVariable, element.point) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- uResol Column -->
                            <ng-container matColumnDef="uResol">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.uResol.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.uResol">
                                  {{ element.uResol | number:'1.' + getDecimalsUncertainty(indexVariable, element.point) +
                                  '-' + getDecimalsUncertainty(indexVariable, element.point) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- uPattern Column -->
                            <ng-container matColumnDef="uPattern">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.uPattern.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element"> {{ joinListUP(indexVariable, element) }} </td>
                            </ng-container>
                            <!-- uUnif Column -->
                            <ng-container matColumnDef="uUnif">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.uUnif.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.uUnif">
                                  {{ element.uUnif != null ? element.uUnif : 'common.notApplicable' | translate }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- uEstab Column -->
                            <ng-container matColumnDef="uEstab">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.uEstab.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.uEstab">
                                  {{ element.uEstab | number:'1.' + getDecimalsUncertainty(indexVariable, element.point) +
                                  '-' + getDecimalsUncertainty(indexVariable, element.point) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- uc Column -->
                            <ng-container matColumnDef="uc">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.uc.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.uC">
                                  {{ element.uC | number:'1.' + getDecimalsUncertainty(indexVariable, element.point) + '-' +
                                  getDecimalsUncertainty(indexVariable, element.point) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- neff Column -->
                            <ng-container matColumnDef="neff">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.neff.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.neff">
                                  {{ element.neff | number:'1.' + getDecimalsUncertainty(indexVariable, element.point) + '-'
                                  + getDecimalsUncertainty(indexVariable, element.point) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- k Column -->
                            <ng-container matColumnDef="k">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.k.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.k">
                                  {{ element.k }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- U Column -->
                            <ng-container matColumnDef="U">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element">
                                <span [matTooltip]="element.U">
                                  {{ element.U | number:'1.' + getDecimalsUncertainty(indexVariable, element.point) + '-' +
                                  getDecimalsUncertainty(indexVariable, element.point) }}
                                </span>
                              </td>
                            </ng-container>
                            <!-- measureUnit Column -->
                            <ng-container matColumnDef="measureUnit">
                              <th mat-header-cell *matHeaderCellDef>
                              {{ 'calibrateEquipmentEdit.uncertainties.cols.measureUnit.label' | translate }} </th>
                              <td mat-cell *matCellDef="let element"> {{ variable.unitName }} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="uncertaintiesCols"></tr>
                            <tr mat-row *matRowDef="let row; columns: uncertaintiesCols;"></tr>
                          </table>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (showAmbientConditions(indexVariable) && !calibration.multichannel) {
                  <mat-card class="card">
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.ambientConditions.particleContainer.title' | translate }}
                      </mat-toolbar>
                      <div fxLayout="column">
                        <div fxFlex>
                          <div>
                            <button mat-raised-button color="primary" (click)="openAmbientCalibration(indexVariable)">
                            {{ 'button.upload-excel' | translate }} </button>
                          </div>
                        </div>
                        @if (variable.valuesParticles != null && variable?.valuesParticles.length > 0) {
                          <div>
                            <br />
                            <strong>{{ 'calibrateEquipmentEdit.ambientConditions.dataParticlesAmbient.result' | translate
                            }}</strong>
                            @for (size of variable?.valuesParticles; track size) {
                              <div
                                [class]="getValidateAmbientParticleNum(indexVariable)">
                                {{ '0.3' }}: {{ size?.zeroThree }}
                                <br />
                                {{ '1.0' }}: {{ size?.oneZero }}
                                <br />
                                {{ 'calibrateEquipmentEdit.ambientConditions.table.porcentaje' | translate }}: {{
                                getSizeAmbientParticleNum(indexVariable) | number: '1.2-2'}} %
                                <br />
                                {{ 'calibrateEquipmentEdit.ambientConditions.table.criteriaAceptation' | translate }}: {{
                                criteriaAceptationParticles }}%
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (calibration.multichannel && variable.config) {
                  <mat-card>
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.multichannel.title' | translate }}
                      </mat-toolbar>
                      <mat-tab-group style="width: 100%;" (selectedTabChange)="onVariableTabChangeMultichannel($event)">
                        @for (multichannel of variable.valuesMultichannel; track multichannel; let indexChannel = $index) {
                          <mat-tab
                            style="min-height: 50vh;" label="{{ multichannel.description }}">
                            @if (calibration.multichannel) {
                              <mat-card class="card">
                                <mat-card-content>
                                  <mat-toolbar color="secondary">
                                    {{ 'calibrateEquipmentEdit.asFound.title' | translate }}
                                    @if (!isEditable()) {
                                      <button mat-icon-button color="accent" (click)="newAsFoundRowMultichannel(indexVariable, indexChannel)"
                                        >
                                        <mat-icon>add</mat-icon>
                                      </button>
                                    }
                                  </mat-toolbar>
                                  <div fxLayout="column" class="flexwrap">
                                    <div fxFlex>
                                      <table #asFoundTableMultiChannel mat-table [dataSource]="multichannel.asFound" style="width: 100%;">
                                        <!-- Number Column -->
                                        <ng-container matColumnDef="number">
                                          <th mat-header-cell *matHeaderCellDef> </th>
                                          <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }} </td>
                                        </ng-container>
                                        <!-- Point Column -->
                                        <ng-container matColumnDef="point">
                                          <th mat-header-cell *matHeaderCellDef>
                                          {{ 'calibrateEquipmentEdit.asFound.cols.point.label' | translate }} </th>
                                          <td mat-cell *matCellDef="let element"> {{ element.point }} </td>
                                        </ng-container>
                                        <!-- Pattern Column -->
                                        <ng-container matColumnDef="pattern">
                                          <th mat-header-cell *matHeaderCellDef>
                                          {{ 'calibrateEquipmentEdit.asFound.cols.pattern.label' | translate }} </th>
                                          <td mat-cell *matCellDef="let element"> {{ element.pattern }} </td>
                                        </ng-container>
                                        <!-- Equipment Column -->
                                        <ng-container matColumnDef="equipment">
                                          <th mat-header-cell *matHeaderCellDef>
                                          {{ 'calibrateEquipmentEdit.asFound.cols.equipment.label' | translate }} </th>
                                          <td mat-cell *matCellDef="let element">
                                            {{ element.equipment | number:'1.' + getDecimalsResolution(indexVariable,
                                            element.point)
                                            +
                                            '-' + getDecimalsResolution(indexVariable, element.point) }}
                                          </td>
                                        </ng-container>
                                        <!-- Correction Column -->
                                        <ng-container matColumnDef="correction">
                                          <th mat-header-cell *matHeaderCellDef>
                                          {{ 'calibrateEquipmentEdit.asFound.cols.correction.label' | translate }} </th>
                                          <td mat-cell *matCellDef="let element"> {{ element.correction }} </td>
                                        </ng-container>
                                        <!-- Button edit Column -->
                                        <ng-container matColumnDef="edit">
                                          <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                                          <td mat-cell *matCellDef="let element; let i = index">
                                            @if (!isEditable()) {
                                              <button mat-icon-button (click)="editAsFoundRowMultichannel(indexVariable, i, indexChannel)"
                                                >
                                                <mat-icon>mode_edit</mat-icon>
                                              </button>
                                            }
                                          </td>
                                        </ng-container>
                                        <!-- Button delete Column -->
                                        <ng-container matColumnDef="delete">
                                          <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                                          <td mat-cell *matCellDef="let element; let i = index">
                                            @if (!isEditable()) {
                                              <button mat-icon-button (click)="deleteAsFoundRowMultichannel(indexVariable, i, indexChannel)"
                                                >
                                                <mat-icon>delete</mat-icon>
                                              </button>
                                            }
                                          </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="asFoundCols"></tr>
                                        <tr mat-row *matRowDef="let row; columns: asFoundCols;"></tr>
                                      </table>
                                    </div>
                                  </div>
                                </mat-card-content>
                              </mat-card>
                            }
                            <mat-card class="card">
                              <mat-card-content>
                                <mat-toolbar color="secondary">
                                  {{ 'calibrateEquipmentEdit.asLeft.title' | translate }}
                                </mat-toolbar>
                                <div fxLayout="column" class="flexwrap">
                                  <div fxFlex>
                                    <table #asLeftTableMultiChannel mat-table
                                      [dataSource]="getAsLeftListMultichannel(indexVariable, indexChannel)"
                                      style="width: 100%;">
                                      <!-- Number Column -->
                                      <ng-container matColumnDef="number">
                                        <th mat-header-cell *matHeaderCellDef> </th>
                                        <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }} </td>
                                      </ng-container>
                                      <!-- Point Column -->
                                      <ng-container matColumnDef="point">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.asLeft.cols.point.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element"> {{ element.point }} </td>
                                      </ng-container>
                                      <!-- Pattern Column -->
                                      <ng-container matColumnDef="pattern">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.asLeft.cols.pattern.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element"> {{ element.pattern }} </td>
                                      </ng-container>
                                      <!-- Values Column -->
                                      <ng-container matColumnDef="value">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.asLeft.cols.value.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element"> {{ joinListValues(indexVariable, element) }}
                                        </td>
                                      </ng-container>
                                      <!-- Average Column -->
                                      <ng-container matColumnDef="average">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.asLeft.cols.average.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.average">
                                            {{ element.average | number:'1.' + (getDecimalsResolution(indexVariable,
                                            element.point) +
                                            1) + '-' + (getDecimalsResolution(indexVariable, element.point) + 1) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- Correction Column -->
                                      <ng-container matColumnDef="correction">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.asLeft.cols.correction.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.correction">
                                            {{ element.correction | number:'1.' + getDecimalsPattern(element.pattern) + '-' +
                                            getDecimalsPattern(element.pattern) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- U Column -->
                                      <ng-container matColumnDef="U">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.U">
                                            {{ element.U | number:'1.' + getDecimalsUncertainty(indexVariable, element.point)
                                            + '-' +
                                            getDecimalsUncertainty(indexVariable, element.point) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- cPlusU Column -->
                                      <ng-container matColumnDef="cPlusU">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.asLeft.cols.cPlusU.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [class]="styleCPlusU(indexVariable, element.point, element.cPlusU)"
                                            [matTooltip]="element.cPlusU">
                                            {{ element.cPlusU | number:'1.' + getDecimalsUncertainty(indexVariable,
                                            element.point) +
                                            '-' + getDecimalsUncertainty(indexVariable, element.point) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- Button see Column -->
                                      <ng-container matColumnDef="edit">
                                        <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                                        <td mat-cell *matCellDef="let element; let i = index">
                                          @if (!isEditable()) {
                                            <button mat-icon-button
                                              (click)="editAsLeftRowMultichannel(indexVariable, indexChannel, i)">
                                              <mat-icon>mode_edit</mat-icon>
                                            </button>
                                          }
                                        </td>
                                      </ng-container>
                                      <tr mat-header-row *matHeaderRowDef="asLeftCols"></tr>
                                      <tr mat-row *matRowDef="let row; columns: asLeftCols;"></tr>
                                    </table>
                                  </div>
                                </div>
                              </mat-card-content>
                            </mat-card>
                            <mat-card class="card">
                              <mat-card-content>
                                <mat-toolbar color="secondary">
                                  {{ 'calibrateEquipmentEdit.uncertainties.title' | translate }}
                                </mat-toolbar>
                                <div fxLayout="column" class="flexwrap">
                                  <div fxFlex>
                                    <table #uncertaintiesTable mat-table
                                      [dataSource]="getAsLeftListMultichannel(indexVariable, indexChannel)"
                                      style="width: 100%;">
                                      <!-- Number Column -->
                                      <ng-container matColumnDef="number">
                                        <th mat-header-cell *matHeaderCellDef> </th>
                                        <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }} </td>
                                      </ng-container>
                                      <!-- Point Column -->
                                      <ng-container matColumnDef="point">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.average.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element; let i = index">
                                          <span [matTooltip]="element.average">
                                            {{ element.average | number:'1.' + getDecimalsResolution(indexVariable,
                                            element.point) +
                                            '-' + getDecimalsResolution(indexVariable, element.point) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- uRep Column -->
                                      <ng-container matColumnDef="uRep">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.uRep.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.uRep">
                                            {{ element.uRep | number:'1.' + getDecimalsUncertainty(indexVariable,
                                            element.point) + '-'
                                            + getDecimalsUncertainty(indexVariable, element.point) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- uResol Column -->
                                      <ng-container matColumnDef="uResol">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.uResol.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.uResol">
                                            {{ element.uResol | number:'1.' + getDecimalsUncertainty(indexVariable,
                                            element.point) +
                                            '-' + getDecimalsUncertainty(indexVariable, element.point) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- uPattern Column -->
                                      <ng-container matColumnDef="uPattern">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.uPattern.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element"> {{ joinListUP(indexVariable, element) }} </td>
                                      </ng-container>
                                      <!-- uUnif Column -->
                                      <ng-container matColumnDef="uUnif">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.uUnif.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.uUnif">
                                            {{ element.uUnif != null ? element.uUnif : 'common.notApplicable' | translate }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- uEstab Column -->
                                      <ng-container matColumnDef="uEstab">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.uEstab.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.uEstab">
                                            {{ element.uEstab | number:'1.' + getDecimalsUncertainty(indexVariable,
                                            element.point) +
                                            '-' + getDecimalsUncertainty(indexVariable, element.point) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- uc Column -->
                                      <ng-container matColumnDef="uc">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.uc.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.uC">
                                            {{ element.uC | number:'1.' + getDecimalsUncertainty(indexVariable, element.point)
                                            + '-' +
                                            getDecimalsUncertainty(indexVariable, element.point) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- neff Column -->
                                      <ng-container matColumnDef="neff">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.neff.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.neff">
                                            {{ element.neff | number:'1.' + getDecimalsUncertainty(indexVariable,
                                            element.point) + '-'
                                            + getDecimalsUncertainty(indexVariable, element.point) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- k Column -->
                                      <ng-container matColumnDef="k">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.k.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.k">
                                            {{ element.k }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- U Column -->
                                      <ng-container matColumnDef="U">
                                        <th mat-header-cell *matHeaderCellDef>
                                        {{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' | translate }} </th>
                                        <td mat-cell *matCellDef="let element">
                                          <span [matTooltip]="element.U">
                                            {{ element.U | number:'1.' + getDecimalsUncertainty(indexVariable, element.point)
                                            + '-' +
                                            getDecimalsUncertainty(indexVariable, element.point) }}
                                          </span>
                                        </td>
                                      </ng-container>
                                      <!-- measureUnit Column -->
                                      <ng-container matColumnDef="measureUnit">
                                        <th mat-header-cell *matHeaderCellDef>
                                          {{ 'calibrateEquipmentEdit.uncertainties.cols.measureUnit.label' | translate }}
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{ variable.unitName }} </td>
                                      </ng-container>
                                      <tr mat-header-row *matHeaderRowDef="uncertaintiesCols"></tr>
                                      <tr mat-row *matRowDef="let row; columns: uncertaintiesCols;"></tr>
                                    </table>
                                  </div>
                                </div>
                              </mat-card-content>
                            </mat-card>
                          </mat-tab>
                        }
                      </mat-tab-group>
                    </mat-card-content>
                  </mat-card>
                }
              </mat-tab>
            }
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    }

    @if (calibration.id != null) {
      <mat-card class="card">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'calibrateEquipmentEdit.result.title' | translate }}
          </mat-toolbar>
          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
            <div fxFlex="80" fxFlex.lt-md="100%">
              <mat-radio-group [(ngModel)]="calibration.correct" name="correct" [disabled]="isEditable()">
                <mat-radio-button [value]="true"> {{'common.correct' | translate}} </mat-radio-button>
                <mat-radio-button [value]="false"> {{'common.incorrect' | translate}} </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }

    <mat-card class="card">
      <mat-card-content>
        <mat-toolbar color="secondary">
          {{ 'calibrateEquipmentEdit.observations.title' | translate }}
        </mat-toolbar>

        <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

          <div fxFlex="80" fxFlex.lt-md="100%">
            <mat-label>{{ 'calibrateEquipmentEdit.observations.label' | translate }}</mat-label>
            <textarea matInput
              [(ngModel)]="calibration.observations" name="observations" style="resize: none;">
            </textarea>
          </div>

        </div>

      </mat-card-content>
    </mat-card>

    <mat-card class="card">
      <mat-card-actions>
        <div fxFlex></div>
        @if (showRevertSign()) {
          <button mat-raised-button color="primary" (click)="revertSign()">
          {{ 'button.revertSign' | translate }} </button>
        }
        @if (showBack()) {
          <div  fxFlex="0.5"></div>
        }
        @if (showBack()) {
          <button mat-raised-button color="primary" (click)="calculateBack()">
          {{ 'button.retreat' | translate }}</button>
        }
        @if (userCanModify()) {
          <div  fxFlex="0.5"></div>
        }
        @if (userCanModify()) {
          <button mat-raised-button color="primary" (click)="saveCalibration()">
          {{ 'button.save' | translate }}</button>
        }
        @if (showAdvance()) {
          <div  fxFlex="0.5"></div>
        }
        @if (showAdvance()) {
          <button mat-raised-button color="primary" (click)="calculateAdvance()">
          {{ 'button.advance' | translate }}</button>
        }
        @if (showManualSign()) {
          <div  fxFlex="0.5"></div>
        }
        @if (showManualSign()) {
          <button mat-raised-button color="primary" (click)="manualSign()">
          {{ 'button.sign-manual' | translate }}</button>
        }
        @if (showAutomaticSign()) {
          <div  fxFlex="0.5"></div>
        }
        @if (showAutomaticSign()) {
          <button mat-raised-button color="primary" (click)="automaticSign()">
          {{ 'button.sign-automatic' | translate }}</button>
        }
        @if (showDownloadButton()) {
          <div  fxFlex="0.5"></div>
        }
        @if (showDownloadButton()) {
          <button mat-raised-button color="accent" (click)="downloadPdf() ">
          {{ 'button.download-certificate' | translate }}</button>
        }
        @if (showInvalidate()) {
          <div  fxFlex="0.5"></div>
        }
        @if (showInvalidate()) {
          <button mat-raised-button color="primary" (click)="invalidate()">
          {{ 'button.invalidate' | translate }}</button>
        }
        <div  fxFlex="0.5"></div>
        <button mat-raised-button color="secondary" (click)="cancel()">{{ 'button.cancel' | translate }}</button>
      </mat-card-actions>
    </mat-card>

  </form>

</mat-tab>
@if (calibration.id != null) {
  <mat-tab label="{{ 'calibrateEquipmentEdit.historical.title' | translate }}">
    <app-calibration-edit-audit [idCalibration]="calibration.id" [documentCode]="calibration.certificateNum"
      [calibration]="calibration" [equipment]="equipment">
    </app-calibration-edit-audit>
  </mat-tab>
}
</mat-tab-group>